import { gql } from 'graphql-request'

export const QueryBlockFaqTop = gql`
  fragment FragmentBlockFaqTop on BlockFAQTopModelRecord {
    __typename
    id
    title
    action {
      ...FragmentNavigationItem
    }
    questions {
      title
      description {
        value
        links {
          ...FragmentLinkReferences
        }
        blocks {
          id
        }
      }
    }
    description {
      value
      links {
        ...FragmentLinkReferences
      }
      blocks {
        id
      }
    }
    theme
  }
`

export const BlockFaqTop = {
  __typename: 'BlockFaqTop',
  fragmentName: 'FragmentBlockFaqTop',
  fragmentQuery: QueryBlockFaqTop,
  fragments: ['FragmentNavigationItem']
}
